import "./Footer.css"
import logo from "../../components/images/mobilelogo.png";
import instagram from "../../components/images/instagram.png";
import facebook from "../../components/images/facebook.png";
import youtube from "../../components/images/Youtube.png";
import darkmd from "../../components/images/darkmode.png";
import { Link } from "react-router-dom";

const Footer = ({dark, setDark, darktoggle, darkTog}) => {
    return <footer>
        <nav>
            <div className="col1">
                <span>
                    <img src={logo} alt=""  className="logo"/>
                    <Link to="/"> <h1 style={{color: "#fafaff"}}>FadaSports</h1></Link>
                </span>
                <p>Join over 22,214,000 users worldwide!</p>

                <span>
                    <img src={youtube} alt="" />
                    <img src={facebook} alt="" />
                    <img src={instagram} alt="" />
                </span>
            </div>

            <div className="col2">
                <ul>
                    <h2>Company</h2>
                    <Link to="/about-us">
                        <li style={{color: "#fafaff"}}>About Us</li>
                    </Link>
                    <Link to="/contact-us">
                        <li style={{color: "#fafaff"}}>Contact us</li>
                    </Link>
                    <Link to="/privacy-policy">
                        <li style={{color: "#fafaff"}}>Privacy policy</li>
                    </Link>
                    <Link to="/advertise">
                        <li style={{color: "#fafaff"}}>Advertise</li>
                    </Link>
                    <Link to="/career">
                        <li style={{color: "#fafaff"}}>Careers</li>
                    </Link>

                        <nav className="darkmode" style={{marginTop: "-12px", opacity: "0.9"}} onClick={darktoggle}>
                        <div className="darkmode-left" style={{alignItems: "center"}}>
                            <div className={`theme-icon ${darkTog ? "active" : ""}`}>
                                <img src={darkmd} alt=""  style={{ filter: !dark ? "invert(1)" : "invert(0)"}}/>
                            </div>

                            <div className="theme-text">
                            <strong>{!dark ? "Dark Mode" : "Light Mode"}</strong>
                                            
                            </div>
                        </div>

                        </nav>
                </ul>

                <ul>
                    <h2>Resources</h2>
                    <Link to="/livescore"> 
                        <li style={{color: "#fafaff"}}>Livescore</li>
                     </Link>
                     
                    <Link to="/latest-news">
                        <li style={{color: "#fafaff"}}>News</li>
                    </Link>
                    <Link to="/quizzes">
                        <li style={{color: "#fafaff"}}>Quizzes</li>
                    </Link>
                    <Link to="/polls">
                        <li style={{color: "#fafaff"}}>Polls</li>
                    </Link>
                    <Link to="/shop">
                        <li style={{color: "#fafaff"}}>Shop</li>
                    </Link>
                    <Link to="/ai">
                        <li style={{color: "#fafaff"}}>FadaSports AI</li>
                    </Link>
                </ul>


            </div>

        </nav>

        <nav>
                <p>Sign up to our Newsletter</p>
            
            <div>
                <input type="email" placeholder="Input your email" />
                <button>Send</button>
            </div>
        </nav>
    </footer>
};

export default Footer;